export default "__VITE_ASSET__3298d1ea__"